module.exports = __webpack_public_path__ + "img/download-icon.d34ff55c.svg";